export const LINE_HEIGHT = 12; // an approximation of the line height for SVG text.
export const OFFSET_TOP = LINE_HEIGHT / 2; // the price-targets-chart needs top padding because drawing at "y=0" will cut-off content at the top.
export const Y_WINDOW_MAX_RANGE = 1.2; // the y-range of the price-targets-chart's window is 20% above the highest value
export const BARS_CONTAINER_WIDTH = .80; // a percentage size that specifies how much space the lines/bars will occupy within it's container

